<div class="lms-toolbar__item">
  <gl-search
    data-testid="search"
    [placeholder]="'actions.search' | translate"
    [attr.disabled]="showFilterRow ? true : null"
    [value]="term"
    (onKeyup)="search($event.detail.value)"
    (onClose)="search('')"
  ></gl-search>
</div>
